import { render, staticRenderFns } from "./HospitalTable.vue?vue&type=template&id=6a1e104e"
import script from "./HospitalTable.vue?vue&type=script&lang=js"
export * from "./HospitalTable.vue?vue&type=script&lang=js"
import style0 from "./HospitalTable.vue?vue&type=style&index=0&id=6a1e104e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports